<template>
  <el-dialog
    class="payDialog"
    :title="payTitle"
    :visible.sync="showFlag"
    width="600px"
    :close-on-click-modal="false"
    @close="colse('1')"
    height="300px">
        <div class="payDialog-box">
            <div class="payDialog-box-title">选择缴纳方式</div>
            <el-radio-group class="payDialog-box-group" v-model="radioStatus">
                <div style="margin-right:40px;">
                    <el-radio class="payDialog-box-text" label="1">在线支付</el-radio>
                    <div style="font-size:12px; padding-top: 10px;"><span class="pd-mark">*</span> 微信支付宝网银等支付</div>
                </div>
                <div style="margin-right:40px;">
                    <div><el-radio class="payDialog-box-text" label="2" :disabled="!availableAmount">运费转投标保证金</el-radio></div>
                    <div style="font-size:12px; padding: 10px 0 0 23px;">
                        <span>可用运费：</span>
                        <span style="color:#FF3300;">{{availableAmount}}元</span>
                    </div>
                </div>
                <div>
                    <el-radio class="payDialog-box-text" label="3">线下汇款</el-radio>
                    <div style="font-size:12px; padding-top: 10px;"><span class="pd-mark">*</span> 线下银行对公转账</div>
                </div>
            </el-radio-group>
        </div>

        <div slot="footer" class="dialog-footer">
            <form name="Form1" id="formCommitForm1" v-if="radioStatus === '1'"  :action="config.mideaPay" method="post">
                <input type="hidden" :name="key" :value="val"  v-for="(val,key) of payResult" :key="key"/>
                <span class="btn-buy" @click="buyBtn('2')"
                    :style="{'background': availableAmount && radioStatus === '2' ? '#ccc' : '#00BCBF',
                    'border-color': availableAmount && radioStatus === '2' ? '#ccc' : '#00BCBF'}" type="submit">前往缴纳</span>
            </form>
            <el-button v-else v-text="'前往缴纳'" type="primary" @click="colse('2')"></el-button>
        </div>
    </el-dialog>
</template>
<script>
import config from '@/config/user.env.js';
import { costOrderPay, getSupplierFreight } from '../../../../lsrm/api/myBidding.js';
export default {
    name: 'payDialog',
    props: {
        showPd: {
            type: Boolean
        },
        myBidFlag: {
            type: Boolean,
            default() {
                return false;
            }
        },
        payTitle: {
            type: String
        },
        payDialogRowData: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            config,
            radioStatus: '1',
            showFlag: false,
            payResult: {},
            rowData: {},
            availableAmount: ''
        };
    },
    methods: {
        formDataObj() {
            let returnUrl = '';
            if (config.apiUrl !== '/') {
                returnUrl = 'https:' + config.apiUrl + '/api-srm-web/public/bidPayCallBack';
            } else {
                returnUrl = 'https://anapi-sit.annto.com/api-srm-web/public/bidPayCallBack';
            }
            const row = this.rowData;
            const par = {
                orderType: '2',
                bidNo: row.bidNo,
                supplierCode: row.supplierCode,
                supplierName: row.supplierName,
                contactNumber: row.contactNumber,
                returnUrl: returnUrl
            };
            costOrderPay(par).then(res => {
                if (res && +res.code === 0) {
                    this.payResult = JSON.parse(res.data.payResult);
                }
            });
        },
        async buyBtn(type) {
            await this.formDataObj();
            setTimeout(() => {
                document.getElementById('formCommitForm1').submit();
            }, '600');
        },
        colse(type) {
            this.showFlag = false;
            this.$emit('payDialogEvent');
            if (type === '1') { return; }
            if (this.radioStatus === '2') {
                this.$router.push({
                    name: 'payFreight',
                    query: {
                        myBidFlag: this.myBidFlag,
                        payType: '3',
                        id: this.rowData.id,
                        bidNo: this.rowData.bidNo,
                        supplierCode: this.rowData.supplierCode
                    }
                });
            } else if (this.radioStatus === '3') {
                this.$router.push({ name: 'payBidDetail', query: { myBidFlag: this.myBidFlag, payType: '1', id: this.rowData.id } });
            }
        },
        getFreight() {
            getSupplierFreight({
                'bidNo': this.rowData.bidNo,
                'supplierCode': this.rowData.supplierCode
            }).then(res => {
                if (+res.code === 0) {
                    let amount = 0;
                    res.data.forEach(el => {
                        amount += +el.availableAmount;
                    });
                    this.availableAmount = amount.toFixed(2);
                }
            });
        }
    },
    watch: {
        showPd(val) {
            this.showFlag = val;
        },
        payDialogRowData(val) {
            if (this.showFlag) {
                this.radioStatus = '1';
                this.rowData = val;
                this.getFreight();
            }
        }
    }
};
</script>

<style lang="less">
.payDialog {
    .payDialog-box {
        padding: 0 20px;
        box-sizing: border-box;
        .payDialog-box-title {
            margin-bottom:20px;
            color:#333;
            font-size:14px;
        }
        .payDialog-box-text {
            font-weight: 700;
        }
        .payDialog-box-group {
            display: flex;
        }
    }
    .btn-buy {
        background: #00BCBF;
        color: #FFFFFF ;
        outline: none;
        padding: 7px 15px;
        font-size: 12px;
        border-radius: 4px;
        display: inline-block;
        line-height: 1;
        white-space: nowrap;
        cursor: pointer;
        border: 1px solid #00BCBF;
        text-align: center;
        box-sizing: border-box;
        outline: none;
        &:hover {
            background: #33c9cc;
            border-color: #33c9cc;
        }
    }
    .pd-mark {
        color: #f96c5f;
    }
}
</style>
